import { useConnectivity } from "../../api/connectivity.js";
import { Icon, useT } from "@mmm/ui";
/**
 * App-level banner shown while the backend is unreachable. The web app talks
 * only to the API (never the database directly), and useQuery.ts keeps the
 * last-fetched data on screen during an outage — this makes that staleness
 * honest rather than silent. Passive by design: it clears itself the moment a
 * request succeeds again (api/connectivity.ts also revalidates every query on
 * recovery), so there is no manual retry button.
 */
export function ConnectionBanner() {
  const status = useConnectivity();
  const t = useT();

  if (status === "online") return null;

  return (
    <div className="mmm-connection-banner" role="status" aria-live="polite">
      <Icon name="alert" className="mmm-connection-banner-icon" />
      <div className="mmm-connection-banner-body">
        <p className="mmm-connection-banner-title">{t("connectivity.offlineTitle")}</p>
        <p className="mmm-connection-banner-message">{t("connectivity.offlineMessage")}</p>
      </div>
    </div>
  );
}
